import styled from '@emotion/styled';
import Typography from '@mui/material/Typography'; 

export const StyledTypography = styled(Typography)`
  padding: 4px 0px;
  flex: 1;
`;
